import { render, staticRenderFns } from "./DocumentCategory.vue?vue&type=template&id=0ef16bc1"
import script from "./DocumentCategory.vue?vue&type=script&lang=js"
export * from "./DocumentCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports